const actionType = {
    GET_ALL_SOURCE_CONFIGURATION_SUCCESS: 'GET_ALL_SOURCE_CONFIGURATION_SUCCESS',
    GET_ALL_SOURCE_CONFIGURATION_FOR_SIDEBAR_SUCCESS: 'GET_ALL_SOURCE_CONFIGURATION_FOR_SIDEBAR_SUCCESS',
    GET_SOURCE_CONFIGURATION_SUCCESS: 'GET_SOURCE_CONFIGURATION_SUCCESS',
    GET_SOURCE_FIELD_SETTINGS_SUCCESS: 'GET_SOURCE_FIELD_SETTINGS_SUCCESS',
    GET_SOURCE_COLUMNS_SUCCESS: 'GET_SOURCE_COLUMNS_SUCCESS',
    GET_TARGET_COLUMNS_SUCCESS: 'GET_TARGET_COLUMNS_SUCCESS',
    SET_SOURCE_DICTIONARIES_FOR_VIEW_CONFIG: 'SET_SOURCE_DICTIONARIES_FOR_VIEW_CONFIG',
    UPDATE_SOURCE_AND_TARGET_COLUMNS_SUCCESS: 'UPDATE_SOURCE_AND_TARGET_COLUMNS_SUCCESS',
    RESET_SOURCE_DICTIONARIES_FOR_VIEW_CONFIG: 'RESET_SOURCE_DICTIONARIES_FOR_VIEW_CONFIG',
};
export default actionType;